import { PostEditorState } from '../../../../models/post-editor';
import { PostEditorErrorKeys } from '../../../../models/validator-props';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { validator } from './validator';
import { ImmutabilityContext } from '../../states/effects/customImmutabilityContext';

export const validatorStateUpdater = (
  state: PostEditorState,
  postGroupIndex: number,
  severity: ErrorMessageSeverity,
  keys?: PostEditorErrorKeys[]
): PostEditorState => {
  const { update: updateImmutable } = ImmutabilityContext;
  const errors = validator(state.postGroups[postGroupIndex], severity, state.postGroups[postGroupIndex].errors, keys);
  return updateImmutable(state, {
    postGroups: {
      [postGroupIndex]: {
        errors: {
          $errorMerge: errors
        }
      }
    }
  });
};
